<template>
  <router-link
    v-if="name"
    :to="link({ name: name, query: query })"
    class="internal-link"
  >
    <slot/>
  </router-link>
  <span v-else class="internal-link"><slot/></span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    name: {
      type: [Object, String],
      default: ''
    },
    query: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['link'])
  }
}
</script>

<style lang="scss" scoped>
  .internal-link {
    @include reset-link;

    cursor: pointer;
    position: relative;

    transition: opacity $base-transition;

    &:focus {
      // opacity: .83;
      outline: none;
    }

    &::after {
      @include media-up(md) {
        content: '';
      }

      width: 100%;
      height: $border-width;
      @include theme(background-color);

      position: absolute;
      bottom: -2px;
      left: 0;

      transform: scaleX(0);
      transform-origin: right;
      transition: transform .33s ease-in-out;
    }

    &:hover::after {
      transform: scaleX(1);
      transform-origin: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InternalLink.vue